"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FadeEffectHandler = exports.FadeEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class FadeEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Fade;
        this.__typeName = "Fade";
        this.name = "Fade";
        this.harmful = true;
    }
}
exports.FadeEffectArgs = FadeEffectArgs;
let FadeEffectHandler = class FadeEffectHandler {
    apply(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.effectIds = Array.from(enums_1.PRIMARY_ATTRIBUTES).map(attribute => {
            const scoreDecrease = container.getPercentOfBaseAttributeScore(state.targetId, 10, attribute);
            return container.applyDebuff({
                sequence,
                attackerId: state.creatorId,
                targetId: state.targetId,
                effect: new _1.MaxAttributeDecreaseEffectArgs(attribute, scoreDecrease),
                duration: Duration_1.Duration.Permanent,
                supernatural: true,
            });
        });
        if (container.getEffectsOfType(state.targetId, EffectType_1.EffectType.Fade).length === 5) {
            // max fades reached, target dies
            container.applyEffect(sequence, state.creatorId, state.targetId, new _1.DeathEffectArgs(), Duration_1.Duration.Permanent);
        }
    }
    remove(sequence, container, state) {
        for (const effectId of state.meta.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
FadeEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Fade)
], FadeEffectHandler);
exports.FadeEffectHandler = FadeEffectHandler;
